import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import APP_CONFIG from "../../config/appConfig";
import {
  fetchUserDetails,
  getCheckoutClientInfo,
  removeCheckoutClientInfo,
  switchUserRole,
} from "../../services/authService";
import "./SideBarNav.css"; // Refactor this for sidebar styling
import { useUser } from "../../context/UserContext";
import { useConfig } from "../../context/AppConfigContext";
import * as FeatherIcon from "react-feather";
import { JS_CSS_IMG_VERSION } from "../../config/apiConfig";
import UserDropDown from "./userDropDown/UserDropDown";
import { buildAuthenticatedReportUrl } from "../../services/commonService";

export default function SideBarNav() {
  const [style, setMyStyle] = useState({ display: "none" });
  const { user, setUser, handleLogout } = useUser();
  const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];

  const { appConfig } = useConfig();
  const [currentRole, setCurrentRole] = useState(user?.role);
  const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);
  const user_roles = !user?.roles ? [] : user?.roles;
  const salesPlayAccess = user?.salesplay ?? 0;
  const user_roles_keys = !appConfig?.user_roles_api
    ? []
    : appConfig?.user_roles_api;
  const [filteredRoles, setFilteredRoles] = useState([]);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const company_id = user?.company_id;
  const company_name = user?.company_name;
  const benchmark_url_temp = "/benchmarks/" + company_id + "/" + company_name;
  const comp_profile_url_temp = "/clients_competitors/" + company_id;
  const token = localStorage.getItem("access_token");
  const selectedClient = admin_roles.includes(user?.growth_iq_role_name)
    ? localStorage.getItem("selectedClient")
    : user?.company_name_for_growth_iq;
  const [nav_urls, setNavUrls] = useState({
    dashboard_url: "/dashboard",
    sales_demo_url: "/client_industry",
    watchboard_url: "/watchboard",
    benchmark_url: benchmark_url_temp,
    comp_profile_url: comp_profile_url_temp,
    revenue_url: "/revenue_teardown",
    external_website_url: "/external_website",
    weekly_report_url: "/weekly_report",
    meeting_preps_url: "/meeting_preps",
    ai_assistannt_url: "/ai_assistant",
  });
  const navigate = useNavigate();

  // +++++++++++++++++++++++++++++++
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [paneTitle, setPaneTitle] = useState("");
  const [paneLinks, setPaneLinks] = useState([]);

  const openPane = (title) => {
    // if (title === "Competitors" || title === "Customers") {
    if (title === "Competitors") {
      setPaneTitle(title);
      setPaneLinks([]);
      setTimeout(() => {
        setPaneLinks(paneContentMap[title] || []);
      }, 100);
      setIsPaneOpen(true);
    } else if (title === "Growth IQ") {
      setIsPaneOpen(false);
      navigate(nav_urls.sales_demo_url);
    } else if (title === "Ask Growth") {
      setIsPaneOpen(false);
      navigate(nav_urls.watchboard_url);
    } else if (title === "Markets") {
      setIsPaneOpen(false);
      if (
        user?.growth_iq_role_name === "ROLE_MNM_SUBSCRIBER" ||
        user?.demo === APP_CONFIG?.market_iq_demo
      )
        navigate("/markets");
      else
        window.open(
          buildAuthenticatedReportUrl("https://www.mnmks.com"),
          "_blank",
          "noopener,noreferrer"
        );
    } else if (title === "Weekely CI" || title === "Documents") {
      setIsPaneOpen(false);
      navigate(nav_urls.weekly_report_url);
    } else if (title === "Customers") {
      setIsPaneOpen(false);
      navigate(nav_urls.external_website_url);
    } else {
      setIsPaneOpen(false);
    }
  };

  // +++++++++++++++++++++++++++++++

  const getRoleKeyByRole = (role) => {
    for (const role_key in user_roles_keys) {
      if (parseInt(user_roles_keys[role_key]) === parseInt(role)) {
        return role_key;
      }
    }
    return "";
  };

  useEffect(() => {
    if (appConfig) {
      const current_role = user?.role;
      setCurrentRole(current_role);
      const user_role_key = getRoleKeyByRole(current_role);
      setCurrentRoleKey(user_role_key);

      const configUserRoles = appConfig.user_roles;
      const updatedFilteredRoles = Object.keys(configUserRoles).filter(
        (role) =>
          user_roles.includes(parseInt(role)) &&
          parseInt(role) !== parseInt(currentRole)
      );
      setFilteredRoles(updatedFilteredRoles);
    }
  }, [appConfig, currentRole, user_roles, currentRoleKey]);

  useEffect(() => {
    if (location.pathname.includes("dashboard")) {
      setActiveMenu("clients_dashboard");
    } else if (location.pathname.startsWith("/client_industry")) {
      setActiveMenu("client_industry");
    } else if (location.pathname.startsWith("/watchboard")) {
      setActiveMenu("watchboard");
    } else if (location.pathname.startsWith("/markets")) {
      setActiveMenu("markets");
    } else if (location.pathname.startsWith("/benchmarks")) {
      setActiveMenu("benchmarks");
    } else if (location.pathname.startsWith("/clients_competitors")) {
      setActiveMenu("clients_competitors");
    } else if (location.pathname.startsWith("/comp_profile")) {
      setActiveMenu("comp_profile");
    } else if (location.pathname.startsWith("/revenue_teardown")) {
      setActiveMenu("revenue_teardown");
    } else if (location.pathname.startsWith("/weekly_report")) {
      setActiveMenu("weekly_report");
    } else if (location.pathname.startsWith("/customers")) {
      setActiveMenu("customers");
    } else if (location.pathname.includes("ai_assistant")) {
      setActiveMenu("ai_assistant");
    } else if (location.pathname.startsWith("/deep_research")) {
      setActiveMenu("deep_research");
    } else if (location.pathname.includes("external_website")) {
      setActiveMenu("customers");
    } else if (location.pathname.startsWith("/meeting_preps")) {
      setActiveMenu("meeting_preps_url");
    } else if (location.pathname.startsWith("/news")) {
      setActiveMenu("livesignals");
    } else {
      setActiveMenu("");
    }

    const checkoutClientInfo = getCheckoutClientInfo();
    const client_id = checkoutClientInfo?.checkoutClientId || "";
    const client_name = checkoutClientInfo?.checkoutClientName || "";

    const updatedUrls =
      client_id && client_name
        ? {
            dashboard_url: "/dashboard",
            sales_demo_url: "/client_industry",
            // markets_url:
            //   "https://stage1.mnmks.com?token=" + encodeURIComponent(token),
            // markets_url: buildAuthenticatedReportUrl(
            //   "https://stage1.mnmks.com"
            // ),
            markets_url: buildAuthenticatedReportUrl("https://www.mnmks.com"),
            companies_url: `/clients_accounts/${client_id}/${client_name}`,
            watchboard_url: "/watchboard",
            benchmark_url: benchmark_url_temp,
            competitors_url: `/clients_competitors/${client_id}/${client_name}`,
            comp_profile_url: comp_profile_url_temp,
            revenue_url: "/revenue_teardown",
            weekly_report_url: "/weekly_report",
            external_website_url: "/external_website",
            meeting_preps_url: "/meeting_preps",
            ai_assistannt_url: "/ai_assistant",
          }
        : {
            dashboard_url: "/dashboard",
            sales_demo_url: "/client_industry",
            // markets_url:
            //   "https://stage1.mnmks.com?token=" + encodeURIComponent(token),
            // markets_url: buildAuthenticatedReportUrl(
            //   "https://stage1.mnmks.com"
            // ),
            markets_url: buildAuthenticatedReportUrl("https://www.mnmks.com"),
            companies_url: "/clients_accounts",
            watchboard_url: "/watchboard",
            benchmark_url: benchmark_url_temp,
            competitors_url: `/clients_competitors/${client_id}/${selectedClient}`,
            comp_profile_url: comp_profile_url_temp,
            revenue_url: "/revenue_teardown",
            weekly_report_url: "/weekly_report",
            external_website_url: "/external_website",
            meeting_preps_url: "/meeting_preps",
            ai_assistannt_url: "/ai_assistant",
          };

    setNavUrls(updatedUrls);
  }, [location.pathname, paneLinks]);

  const switchUser = async (role) => {
    removeCheckoutClientInfo();
    const { access_token } = await switchUserRole(parseInt(role));
    if (access_token) {
      const user_role_key = getRoleKeyByRole(role);
      const userInfo = await fetchUserDetails();
      setUser(userInfo);
      setCurrentRole(role);

      // if (user_role_key === "SALES_DEMO") {
      //   navigate("/sales_accounts");
      // } else if (
      //   user_role_key === "CLIENT" ||
      //   user_role_key === "CLIENT_EMPLOYEE"
      // ) {
      //   if (!userInfo?.is_onboarded) {
      //     navigate("/user_profile/profile");
      //   } else {
      //     navigate("/watchboard");
      //   }
      // } else if (user_role_key === "ANALYST") {
      //   navigate("/demo_requests");
      // } else {
      //   navigate("/watchboard");
      // }
    }
  };

  // +++++++++++++++++++++++++++++++++++++++++++
  // PANE CONTENT DEFINITION WITH LINKS
  const paneContentMap = {
    // Markets: [
    //   { name: "Market Deep Dive", url: nav_urls.markets_url },
    //   { name: "Go/No Go Decision", url: nav_urls.markets_url },
    //   { name: "SAM/SOM Calculator", url: nav_urls.markets_url },
    //   { name: "Market Entry Strategy", url: nav_urls.markets_url },
    // ],
    Competitors: [
      { name: "Competitor Profile", url: nav_urls.comp_profile_url },
      // show only if NOT market_iq_demo
      ...(user?.demo !== APP_CONFIG?.market_iq_demo
        ? [
            { name: "Benchmarking", url: nav_urls.benchmark_url },
            { name: "Revenue Teardown", url: nav_urls.revenue_url },
          ]
        : []),
      { name: "News", url: nav_urls.weekly_report_url },
      // { name: "Benchmarking", url: nav_urls.benchmark_url },
      // { name: "Revenue Teardown", url: nav_urls.revenue_url },
    ],
    // Customers: [
    //   { name: "Customer Profile", url: nav_urls.weekely_report_url },
    //   { name: "Segment Explorer", url: nav_urls.weekely_report_url },
    //   { name: "Voice of Customer", url: nav_urls.weekely_report_url },
    // ],
  };

  // +++++++++++++++++++++++++++++++++++++++++++++++++
  useEffect(() => {
    if (appConfig) {
      let current_role = user?.role;
      setCurrentRole(current_role);

      let user_role_key = getRoleKeyByRole(current_role);
      setCurrentRoleKey(user_role_key);

      const configUserRoles = appConfig.user_roles;
      const updatedFilteredRoles = Object.keys(configUserRoles).filter(
        (role) =>
          user_roles.includes(parseInt(role)) &&
          parseInt(role) !== parseInt(currentRole)
      );
      setFilteredRoles(updatedFilteredRoles);
    }
  }, [appConfig, currentRole, user_roles, currentRoleKey]);

  const configUserRoles = appConfig.user_roles;
  // +++++++++++++++++++++++++++++++++++++++++++++++++

  // PANE CONTENT DEFINITION WITH LINKS
  // +++++++++++++++++++++++++++++++++++++++++++

  // if (!appConfig) return null;

  return (
    <div className="client-layout-main-layout-sidebar">
      <ul className="sidebar-menu">
        {(currentRoleKey === "CLIENT" ||
          currentRoleKey === "CLIENT_EMPLOYEE" ||
          currentRoleKey === "SALES_DEMO") && (
          <>
            <li>
              <Link
                className="d-block text-center"
                // to={nav_urls.watchboard_url}
              >
                <img
                  src="/img/mnm_logo.png?version=2.1"
                  alt="logo"
                  width="50"
                  className=""
                ></img>
              </Link>
            </li>

            {/* ++++++++++++++++++++++++++++++++++++++++ */}
            {admin_roles.includes(user?.growth_iq_role_name) && (
              <li className={activeMenu === "client_industry" ? "active" : ""}>
                <Link
                  // to="#"
                  // to="/client_industry"
                  onClick={(e) => {
                    e.preventDefault();
                    openPane("Growth IQ");
                  }}
                  className="sidebar-container-primary-nav-el"
                >
                  <FeatherIcon.Airplay className="sidebar-container-primary-nav-el-icon" />{" "}
                  <div className="side_head">Sales Demo</div>
                </Link>
              </li>
            )}

            {(admin_roles.includes(user?.growth_iq_role_name) ||
              user?.has_ask_growth_access === 1) && (
              <li className={activeMenu === "watchboard" ? "active" : ""}>
                <Link
                  // to={nav_urls.watchboard_url}
                  to="#"
                  className="sidebar-container-primary-nav-el"
                  onClick={(e) => {
                    e.preventDefault();
                    openPane("Ask Growth");
                  }}
                >
                  <FeatherIcon.Airplay className="sidebar-container-primary-nav-el-icon" />{" "}
                  <div className="side_head">Ask Growth IQ</div>
                </Link>
              </li>
            )}
            {/* ++++++++++++++++++++++++++++++++++++++++ */}

            {/* Markets - Only visible for demo === "8" users */}
            {
              // admin_roles.includes(user?.growth_iq_role_name) && (
              // || user?.demo === APP_CONFIG?.market_iq_demo
              <li className={activeMenu === "markets" ? "active" : ""}>
                <Link
                  to="#"
                  className="sidebar-container-primary-nav-el"
                  onClick={(e) => {
                    e.preventDefault();
                    openPane("Markets");
                  }}
                >
                  <FeatherIcon.Airplay className="sidebar-container-primary-nav-el-icon" />{" "}
                  <div className="side_head">Markets</div>
                </Link>
              </li>
            }

            {/* <li className={activeMenu === "benchmarks" ? "active" : ""}>
              <Link
                to={nav_urls.benchmark_url}
                className="sidebar-container-primary-nav-el"
              >
                <FeatherIcon.Box className="sidebar-container-primary-nav-el-icon" />{" "}
                <div className="side_head">Benchmarks</div>
              </Link>
            </li> */}
            {
              <>
                {(admin_roles.includes(user?.growth_iq_role_name) ||
                  user?.has_comp_iq_access === 1) && (
                  <li
                    className={
                      activeMenu === "clients_competitors" ||
                      activeMenu === "comp_profile" ||
                      activeMenu === "benchmarks" ||
                      activeMenu === "revenue_teardown" ||
                      activeMenu === "weekly_report"
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="#"
                      className="sidebar-container-primary-nav-el"
                      onClick={(e) => {
                        e.preventDefault();
                        openPane("Competitors");
                      }}
                    >
                      <FeatherIcon.Box className="sidebar-container-primary-nav-el-icon" />{" "}
                      <div className="side_head">Competitors</div>
                    </Link>
                  </li>
                )}
                {(admin_roles.includes(user?.growth_iq_role_name) ||
                  salesPlayAccess === 1) && (
                  <li className={activeMenu === "customers" ? "active" : ""}>
                    <Link
                      to="/customers"
                      className="sidebar-container-primary-nav-el"
                    >
                      <FeatherIcon.User className="sidebar-container-primary-nav-el-icon" />{" "}
                      <div className="side_head">Customers</div>
                    </Link>
                  </li>
                )}
                <li className={activeMenu === "livesignals" ? "active" : ""}>
                  <Link to="/news" className="sidebar-container-primary-nav-el">
                    <FeatherIcon.Airplay className="sidebar-container-primary-nav-el-icon" />{" "}
                    <div className="side_head">Live Signals</div>
                  </Link>
                </li>

                {(admin_roles.includes(user?.growth_iq_role_name) ||
                  user?.has_ask_growth_access === 1) && (
                  <li
                    className={activeMenu === "deep_research" ? "active" : ""}
                  >
                    <Link
                      to="/deep_research"
                      className="sidebar-container-primary-nav-el"
                    >
                      <FeatherIcon.FileText className="sidebar-container-primary-nav-el-icon" />{" "}
                      <div className="side_head">Documents</div>
                    </Link>
                  </li>
                )}

                {/*
                    //Links made hidden for now as asked by Payal
                <li className={activeMenu === "documents" ? "active" : ""}>
                  <Link
                    // to={nav_urls.watchboard_url}
                    to="#"
                    className="sidebar-container-primary-nav-el"
                    onClick={(e) => {
                      e.preventDefault();
                      openPane("Documents");
                    }}
                  >
                    <FeatherIcon.Airplay className="sidebar-container-primary-nav-el-icon" />{" "}
                    <div className="side_head">Documents</div>
                  </Link>
                </li> */}
              </>
            }
            {/* <li className={activeMenu === "comp_profile" ? "active" : ""}>
              <Link
                to={nav_urls.comp_profile_url}
                className="sidebar-container-primary-nav-el"
              >
                <FeatherIcon.Box className="sidebar-container-primary-nav-el-icon" />{" "}
                <div className="side_head">Comp Profile</div>
              </Link>
            </li> */}
            {/* <li className={activeMenu === "revenue_teardown" ? "active" : ""}>
              <Link
                to={nav_urls.revenue_url}
                className="sidebar-container-primary-nav-el"
              >
                <FeatherIcon.Zap className="sidebar-container-primary-nav-el-icon" />{" "}
                <div className="side_head">
                  Revenue <br />
                  Teardown
                </div>
              </Link>
            </li> */}
            {/* <li className={activeMenu === "weekly_report" ? "active" : ""}>
              <Link
                // to={nav_urls.weekly_report_url}
                // className="sidebar-container-primary-nav-el"
                to="#"
                className="sidebar-container-primary-nav-el"
                onClick={(e) => {
                  e.preventDefault();
                  openPane("Weekly CI");
                }}
              >
                <FeatherIcon.Calendar className="sidebar-container-primary-nav-el-icon" />{" "}
                <div className="side_head">
                  Weekly <br />
                  CI Report
                </div>
              </Link>
            </li> */}
            {/* <li
                className={activeMenu === "clients_dashboard" ? "active" : ""}
              >
                <Link to={nav_urls.dashboard_url} className="sidebar-container-primary-nav-el">
                  <FeatherIcon.Layout className="sidebar-container-primary-nav-el-icon" />
                  <div className="side_head">Home</div>
                  
                </Link>
              </li> */}
            {/* <li className={activeMenu === "clients_accounts" ? "active" : ""}>
                <Link to={nav_urls.companies_url} className="sidebar-container-primary-nav-el">
                  <FeatherIcon.Box className="sidebar-container-primary-nav-el-icon"/> <div className="side_head">Accounts</div>
                </Link>
              </li>
 
              <li className={activeMenu === "meeting_preps_url" ? "active" : ""}>
                <Link to={nav_urls.meeting_preps_url} className="sidebar-container-primary-nav-el">
                  <FeatherIcon.Calendar className="sidebar-container-primary-nav-el-icon"/> <div className="side_head">Meeting<br />Prep</div>
                </Link>
              </li> */}
            {/* <li className={activeMenu === "ai_assistant" ? "active" : ""}>
                <Link to={`/ai_assistant/${Date.now()}`} className="sidebar-container-primary-nav-el">
                  <img src="/img/ai_icon.png" className="sidebar-container-primary-nav-el-icon"/>
                  <div className="sidebar-container-primary-nav-el side_head"> AI Assistant</div>
                </Link>
              </li> */}
          </>
        )}

        {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
        <li className="initial_block_bottom">
          <UserDropDown
            user={user}
            currentRoleKey={currentRoleKey}
            filteredRoles={filteredRoles}
            configUserRoles={configUserRoles}
            switchUser={switchUser}
            handleLogout={handleLogout}
          />
        </li>
        {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      </ul>

      {/* SIDE PANE JSX */}
      {isPaneOpen && (
        <div className="sidebar-pane">
          <div className="pane-header">
            <span className="pane_title_custom">{paneTitle}</span>
            <button
              className="close-btn close_btn_pane"
              onClick={() => setIsPaneOpen(false)}
            >
              ✕
            </button>
          </div>
          <ul className="pane-links">
            {paneLinks.map((link, index) => (
              <li
                key={`link.url ${index} ${
                  paneLinks?.length !== 0 ? paneLinks[0].name : ""
                }`}
              >
                <Link
                  to={link.url}
                  {...(link.url.includes("https://stage.mnmks.com")
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  onClick={() => setIsPaneOpen(false)}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* SIDE PANE JSX */}

      {/* <div className="sidebar-footer">
          {location.pathname.indexOf("sales_accounts") === -1 && (
            <li className="nav-item">
              <div className="help_block">
                <Link to="/pages/help_account_iq" className="help_link">
                  <img
                    src="/img/icons/icons_qm.png"
                    className="bell_icon"
                    alt="image_help"
                  />
                  <p className="ai_bottom">Help</p>
                </Link>
              </div>
            </li>
          )}
        </div> */}
    </div>
  );
}
